<template>
    <v-container fluid>
        <page-header title="Faqs" icon="mdi-frequently-asked-questions">
            <template v-slot:actions>
                <v-btn class="white--text" depressed small color="black" @click="createFaq">
                    <v-icon left small>mdi-plus</v-icon>Create
                </v-btn>
            </template>
            <table-filters :fields="filterFields" :value="filterValues" @apply="applyFilters" />
        </page-header>
        <array-view
            :items="faqs"
            :headers="displayInfo"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :sort-by="sort.sortBy"
            :sort-desc="sort.sortDesc"
            @handleClick="handleClick"
            @onDelete="onDelete"
            @paginationChange="paginationChange"
            @sortChange="changeSort"
        />
    </v-container>
</template>

<script>
    import faqService from '@/services/faq'
    import ArrayView from '@/components/ArrayView'
    import TableFilters from '@/components/TableFilters'
    import PageHeader from '@/components/PageHeader'
    import listTable from '@/mixins/listTable'

    export default {
        name: 'Faq',
        components: { ArrayView, TableFilters, PageHeader },
        mixins: [listTable],
        data: () => {
            return {
                successfullImport: null,
                faqs: [],
                displayInfo: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'Question',
                        value: 'question'
                    },
                    {
                        text: 'Answer',
                        value: 'answer'
                    },
                    {
                        text: 'Type',
                        value: 'type'
                    }
                ],
                tableKey: 'faqs',
                filterFields: [
                    { key: 'question', label: 'Question', type: 'text' },
                    { key: 'answer', label: 'Answer', type: 'text' },
                    { key: 'type', label: 'Type', type: 'select', items: ['general'] }
                ],
                showImportDialog: false,
                size: 5,
                totalPages: 0,
                page: 1
            }
        },
        created() {
            this.fetchItems()
        },
        methods: {
            handleClick(action, item) {
                this.$router.push(`/faqs/${item.id}/${action}`)
            },
            createFaq() {
                this.$router.push(`/faqs/create`)
            },
            fetchItems() {
                faqService.getFilteredFaqs(this.filterQuery, this.page, this.size, this.sort).then(resp => {
                    this.faqs = resp.data.content
                    this.totalPages = resp.data.totalPages
                })
            },
            onDelete(faq) {
                faqService.deleteFaq(faq.id).then(resp => {
                    this.fetchItems()
                })
            }
        }
    }
</script>

<style scoped>
.card-title {
    display: flex;
}

.v-list-item {
    min-height: 30px !important;
}

.v-card {
    min-width: 250px;
    position: relative;
}

.header-card {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1%;
}

.header-buttons {
    align-self: center;
}

.edit-button:hover {
    background-color: whitesmoke;
    color: white;
}

.screen-card {
    padding: 4%;
}

.overflow-text {
    max-width: 79%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.pagination {
    justify-content: center;
}
</style>
